export class CorporateEntity {

    public CEID: number = 0;
    public Active: boolean = true;
    public CompanyName: string = '';
    public HiddenGroup: boolean = false;
    public IsHoneywell: boolean = false;
    public CompanyNameWithCEID: string = '';

    constructor(corpEntity: CorporateEntity) {
        this.Active = corpEntity.Active || false;
        this.CEID = corpEntity.CEID || 0;
        this.CompanyName = corpEntity.CompanyName || "";
        this.HiddenGroup = corpEntity.HiddenGroup || false;
        this.IsHoneywell = (corpEntity.IsHoneywell == true ? true : corpEntity.CEID == 100 || corpEntity.CEID ==114 ? true: false)|| false;
        this.CompanyNameWithCEID = corpEntity.CEID > 0 ? corpEntity.CompanyName + ' - (' + corpEntity.CEID + ')' : corpEntity.CompanyName;
    }
}